var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReformChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4378 10.0784L1.42241 4.8957C1.07221 4.69437 0.875 4.42072 0.875 4.13583L0.875 -0.000183105L9.93965 5.21088C10.2584 5.39413 10.4378 5.64286 10.4378 5.90185L10.4378 10.0779L10.4378 10.0784Z",
    fill: "#00FFC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.000194921L10.9846 5.18267C10.6336 5.38447 10.4372 5.65762 10.4372 5.94298L10.4372 10.0788L20 4.58164L20 0.000683202L20 0.000194921Z",
    fill: "#00FFC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReformChevron);
export default __webpack_public_path__ + "static/media/reform-chevron.95ec053f0426954890646e4e0f311993.svg";
export { ForwardRef as ReactComponent };